import { authClient } from "@src/auth/client";
import { signOut } from "@src/okta/tokenManager";
import { Form, Link, redirect } from "react-router-dom";

export function meta() {
  return [{ title: "Logout" }, { name: "description", content: "Sign out" }];
}

export async function clientAction() {
  try {
    await authClient.signOut();
  } catch (error) {
    console.error("Better-auth signOut failed:", error);
  }
  try {
    await signOut("/login");
  } catch (error) {
    console.error("Okta signOut failed:", error);
  }
  return redirect("/login");
}

export default function Logout() {
  return (
    <div style={{ padding: "2rem", textAlign: "center" }}>
      <p>Are you sure you want to log out?</p>
      <Form method="post">
        <button type="submit">Logout</button>
      </Form>
      <Link to="/dashboard">Never mind</Link>
    </div>
  );
}
